import Service from "../Service"

const base = {
    getById(id) {
        return Service.get(`api/base/${id}`)
    },
    getAllBuilding () {
        return Service.get(`api/base-by-type/building?paginate=false`);
    },
    getAllLevelByBuilding (id) {
        return Service.get(`api/base-by-type/level?ref_id=${id}&paginate=false`);
    },
    getAllRoomTypes () {
        return Service.get(`api/base-by-type/room-type?paginate=false`);
    },
    getAllRoomTypegalleryByRoomType (roomTypeId) {
        return Service.get(`api/base-by-type/room-type-gallery`, {
            params: {
                ref_id: roomTypeId,
                paginate: false
            }
        });
    }

};

export default base;
